// extracted by mini-css-extract-plugin
export default {"compare-plans-table":"PlansTable_compare-plans-table__1MFZB","check-icon":"PlansTable_check-icon__0uRFP","left-align":"PlansTable_left-align__jkBX9"};